import { render, staticRenderFns } from "./SettingUserData.vue?vue&type=template&id=3b16d131&scoped=true&"
import script from "./SettingUserData.vue?vue&type=script&lang=js&"
export * from "./SettingUserData.vue?vue&type=script&lang=js&"
import style0 from "./SettingUserData.vue?vue&type=style&index=0&id=3b16d131&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b16d131",
  null
  
)

export default component.exports